'use strict';

//ServiceType key is JET for consistency and its value is S2S due to the license server that also uses the value

module.exports = {
    MEDIASHUTTLE: 'MEDIASHUTTLE',
    FLIGHT_GATEWAY: 'FLIGHT_GATEWAY',
    JET: 'S2S', //Site to Site
    MANAGER_AND_AGENTS_SAAS: 'MANAGER_AND_AGENTS_SAAS',
    MEDIA_ENGINE: 'MEDIA_ENGINE',
    MEDIA_FACTORY: 'MEDIA_FACTORY'
};